export default __webpack_public_path__ + "static/coding-background-9097fcc50c9d6112d3b93541e9504305.png";